// ISO 3166-1 alpha-3 → alpha-2 mapping for the 197 countries we support.
export const ALPHA3_TO_ALPHA2 = {
  AFG: "AF", ALB: "AL", DZA: "DZ", AND: "AD", AGO: "AO", ATG: "AG", ARG: "AR", ARM: "AM",
  AUS: "AU", AUT: "AT", AZE: "AZ", BHS: "BS", BHR: "BH", BGD: "BD", BRB: "BB", BEL: "BE",
  BLZ: "BZ", BEN: "BJ", BTN: "BT", BLR: "BY", BOL: "BO", BIH: "BA", BWA: "BW", BRA: "BR",
  BRN: "BN", BGR: "BG", BFA: "BF", BDI: "BI", CYP: "CY", MNE: "ME", CZE: "CZ", CHL: "CL",
  DNK: "DK", DMA: "DM", DOM: "DO", DJI: "DJ", EGY: "EG", ECU: "EC", GNQ: "GQ", ERI: "ER",
  EST: "EE", SWZ: "SZ", ETH: "ET", FJI: "FJ", PHL: "PH", FIN: "FI", FRA: "FR", GAB: "GA",
  GMB: "GM", GHA: "GH", GRC: "GR", GRD: "GD", GEO: "GE", GUM: "GU", GTM: "GT", GIN: "GN",
  GNB: "GW", GUY: "GY", HTI: "HT", HND: "HN", HRV: "HR", IND: "IN", IDN: "ID", IRQ: "IQ",
  IRN: "IR", IRL: "IE", ISL: "IS", TLS: "TL", ISR: "IL", ITA: "IT", JAM: "JM", JPN: "JP",
  YEM: "YE", JOR: "JO", KOR: "KR", ZAF: "ZA", SSD: "SS", KHM: "KH", CMR: "CM", CAN: "CA",
  QAT: "QA", KAZ: "KZ", KEN: "KE", CHN: "CN", KGZ: "KG", KIR: "KI", COL: "CO", COM: "KM",
  COD: "CD", COG: "CG", PRK: "KP", XKX: "XK", CRI: "CR", CUB: "CU", KWT: "KW", LAO: "LA",
  LVA: "LV", LSO: "LS", LBN: "LB", LBR: "LR", LBY: "LY", LIE: "LI", LTU: "LT", LUX: "LU",
  MDG: "MG", HUN: "HU", MWI: "MW", MDV: "MV", MYS: "MY", MLI: "ML", MLT: "MT", MAR: "MA",
  MHL: "MH", MUS: "MU", MRT: "MR", MEX: "MX", FSM: "FM", MMR: "MM", MDA: "MD", MCO: "MC",
  MNG: "MN", MOZ: "MZ", NAM: "NA", NRU: "NR", NPL: "NP", NER: "NE", NGA: "NG", NIC: "NI",
  NLD: "NL", NOR: "NO", NZL: "NZ", DEU: "DE", OMN: "OM", PAK: "PK", PLW: "PW", PSE: "PS",
  PAN: "PA", PNG: "PG", PRY: "PY", PER: "PE", POL: "PL", PRT: "PT", PRI: "PR", ROU: "RO",
  RUS: "RU", RWA: "RW", SLV: "SV", WSM: "WS", SMR: "SM", SAU: "SA", SYC: "SC", SEN: "SN",
  SLE: "SL", SGP: "SG", SYR: "SY", USA: "US", MKD: "MK", SVK: "SK", SVN: "SI", SLB: "SB",
  SOM: "SO", SRB: "RS", CAF: "CF", SDN: "SD", SUR: "SR", LKA: "LK", ESP: "ES", SWE: "SE",
  CHE: "CH", STP: "ST", KNA: "KN", LCA: "LC", VCT: "VC", TJK: "TJ", THA: "TH", TWN: "TW",
  TZA: "TZ", TGO: "TG", TON: "TO", TTO: "TT", TUN: "TN", TKM: "TM", TUR: "TR", TUV: "TV",
  UGA: "UG", ARE: "AE", GBR: "GB", UKR: "UA", URY: "UY", UZB: "UZ", VUT: "VU", VAT: "VA",
  VEN: "VE", VNM: "VN", ZMB: "ZM", CPV: "CV", ZWE: "ZW",
};

// English country names paired with our Croatian COUNTRIES list, for bilingual search/display.
// (sorted to match the order of integrations/evisitor.COUNTRIES)
export const COUNTRY_NAME_EN = {
  AFG: "Afghanistan", ALB: "Albania", DZA: "Algeria", AND: "Andorra", AGO: "Angola",
  ATG: "Antigua and Barbuda", ARG: "Argentina", ARM: "Armenia", AUS: "Australia", AUT: "Austria",
  AZE: "Azerbaijan", BHS: "Bahamas", BHR: "Bahrain", BGD: "Bangladesh", BRB: "Barbados",
  BEL: "Belgium", BLZ: "Belize", BEN: "Benin", BTN: "Bhutan", BLR: "Belarus",
  BOL: "Bolivia", BIH: "Bosnia and Herzegovina", BWA: "Botswana", BRA: "Brazil", BRN: "Brunei",
  BGR: "Bulgaria", BFA: "Burkina Faso", BDI: "Burundi", CYP: "Cyprus", MNE: "Montenegro",
  CZE: "Czechia", CHL: "Chile", DNK: "Denmark", DMA: "Dominica", DOM: "Dominican Republic",
  DJI: "Djibouti", EGY: "Egypt", ECU: "Ecuador", GNQ: "Equatorial Guinea", ERI: "Eritrea",
  EST: "Estonia", SWZ: "Eswatini", ETH: "Ethiopia", FJI: "Fiji", PHL: "Philippines",
  FIN: "Finland", FRA: "France", GAB: "Gabon", GMB: "Gambia", GHA: "Ghana", GRC: "Greece",
  GRD: "Grenada", GEO: "Georgia", GUM: "Guam", GTM: "Guatemala", GIN: "Guinea", GNB: "Guinea-Bissau",
  GUY: "Guyana", HTI: "Haiti", HND: "Honduras", HRV: "Croatia", IND: "India", IDN: "Indonesia",
  IRQ: "Iraq", IRN: "Iran", IRL: "Ireland", ISL: "Iceland", TLS: "Timor-Leste", ISR: "Israel",
  ITA: "Italy", JAM: "Jamaica", JPN: "Japan", YEM: "Yemen", JOR: "Jordan", KOR: "South Korea",
  ZAF: "South Africa", SSD: "South Sudan", KHM: "Cambodia", CMR: "Cameroon", CAN: "Canada",
  QAT: "Qatar", KAZ: "Kazakhstan", KEN: "Kenya", CHN: "China", KGZ: "Kyrgyzstan",
  KIR: "Kiribati", COL: "Colombia", COM: "Comoros", COD: "DR Congo", COG: "Congo",
  PRK: "North Korea", XKX: "Kosovo", CRI: "Costa Rica", CUB: "Cuba", KWT: "Kuwait",
  LAO: "Laos", LVA: "Latvia", LSO: "Lesotho", LBN: "Lebanon", LBR: "Liberia", LBY: "Libya",
  LIE: "Liechtenstein", LTU: "Lithuania", LUX: "Luxembourg", MDG: "Madagascar", HUN: "Hungary",
  MWI: "Malawi", MDV: "Maldives", MYS: "Malaysia", MLI: "Mali", MLT: "Malta", MAR: "Morocco",
  MHL: "Marshall Islands", MUS: "Mauritius", MRT: "Mauritania", MEX: "Mexico", FSM: "Micronesia",
  MMR: "Myanmar", MDA: "Moldova", MCO: "Monaco", MNG: "Mongolia", MOZ: "Mozambique",
  NAM: "Namibia", NRU: "Nauru", NPL: "Nepal", NER: "Niger", NGA: "Nigeria", NIC: "Nicaragua",
  NLD: "Netherlands", NOR: "Norway", NZL: "New Zealand", DEU: "Germany", OMN: "Oman",
  PAK: "Pakistan", PLW: "Palau", PSE: "Palestine", PAN: "Panama", PNG: "Papua New Guinea",
  PRY: "Paraguay", PER: "Peru", POL: "Poland", PRT: "Portugal", PRI: "Puerto Rico",
  ROU: "Romania", RUS: "Russia", RWA: "Rwanda", SLV: "El Salvador", WSM: "Samoa",
  SMR: "San Marino", SAU: "Saudi Arabia", SYC: "Seychelles", SEN: "Senegal", SLE: "Sierra Leone",
  SGP: "Singapore", SYR: "Syria", USA: "United States", MKD: "North Macedonia", SVK: "Slovakia",
  SVN: "Slovenia", SLB: "Solomon Islands", SOM: "Somalia", SRB: "Serbia", CAF: "Central African Republic",
  SDN: "Sudan", SUR: "Suriname", LKA: "Sri Lanka", ESP: "Spain", SWE: "Sweden",
  CHE: "Switzerland", STP: "São Tomé and Príncipe", KNA: "Saint Kitts and Nevis", LCA: "Saint Lucia",
  VCT: "Saint Vincent and the Grenadines", TJK: "Tajikistan", THA: "Thailand", TWN: "Taiwan",
  TZA: "Tanzania", TGO: "Togo", TON: "Tonga", TTO: "Trinidad and Tobago", TUN: "Tunisia",
  TKM: "Turkmenistan", TUR: "Turkey", TUV: "Tuvalu", UGA: "Uganda", ARE: "United Arab Emirates",
  GBR: "United Kingdom", UKR: "Ukraine", URY: "Uruguay", UZB: "Uzbekistan", VUT: "Vanuatu",
  VAT: "Vatican City", VEN: "Venezuela", VNM: "Vietnam", ZMB: "Zambia", CPV: "Cape Verde",
  ZWE: "Zimbabwe",
};

export function flagSrc(alpha3) {
  const a2 = ALPHA3_TO_ALPHA2[alpha3];
  if (!a2) return null;
  return `https://flagcdn.com/w40/${a2.toLowerCase()}.png`;
}

// ALL 32 eVisitor document types
export const ALL_DOCUMENT_TYPES = [
  { code: "002", name: "Osobna putovnica - strana", group: "passport" },
  { code: "003", name: "Obiteljska putovnica - strana", group: "passport" },
  { code: "004", name: "Zajednička putovnica - strana", group: "passport" },
  { code: "005", name: "Dječja putovnica - strana", group: "passport" },
  { code: "006", name: "Diplomatska putovnica - strana", group: "passport" },
  { code: "007", name: "Službena putovnica - strana", group: "passport" },
  { code: "008", name: "Pomorska knjižica - strana", group: "other" },
  { code: "009", name: "Brodarska knjižica - strana", group: "other" },
  { code: "011", name: "Putni list za strance - izdan od RH", group: "other" },
  { code: "012", name: "Putna isprava za izbjeglice", group: "other" },
  { code: "013", name: "Putna isprava za osobe bez državljanstva", group: "other" },
  { code: "022", name: "Potvrda o oduzimanju putne isprave", group: "other" },
  { code: "023", name: "Potvrda o prijavi gubitka putne isprave", group: "other" },
  { code: "024", name: "Osobna iskaznica za stranca - izdana od RH", group: "id" },
  { code: "025", name: "Posebna osobna iskaznica - diplomatska", group: "id" },
  { code: "026", name: "Isprave izdane na temelju međunarodnih ugovora", group: "other" },
  { code: "027", name: "Osobna iskaznica - strana", group: "id" },
  { code: "028", name: "Osobna putovnica - hrvatska", group: "passport" },
  { code: "029", name: "Pogranična propusnica - strana", group: "other" },
  { code: "030", name: "Izbjeglički karton - izdan od RH", group: "other" },
  { code: "032", name: "Vozačka dozvola - strana", group: "driver" },
  { code: "033", name: "Dječja putovnica - hrvatska", group: "passport" },
  { code: "034", name: "Putni list za strance - strani", group: "other" },
  { code: "035", name: "Zajednička putovnica - hrvatska", group: "passport" },
  { code: "036", name: "Diplomatska putovnica - hrvatska", group: "passport" },
  { code: "037", name: "Službena putovnica - hrvatska", group: "passport" },
  { code: "038", name: "Pomorska iskaznica - hrvatska", group: "other" },
  { code: "039", name: "Ostalo", group: "other" },
  { code: "051", name: "Osobna iskaznica - hrvatska", group: "id" },
  { code: "052", name: "Obiteljska putovnica - hrvatska", group: "passport" },
  { code: "103", name: "Vozačka dozvola - hrvatska", group: "driver" },
  { code: "999", name: "Zdravstvena iskaznica", group: "other" },
];

export const COMMON_DOCS = ["051", "027", "028", "002", "103", "032"];

export const MONTHS_HR = ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"];
export const MONTHS_EN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const MONTHS_DE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
export const MONTHS_IT = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export function monthsFor(lang) {
  return { hr: MONTHS_HR, en: MONTHS_EN, de: MONTHS_DE, it: MONTHS_IT }[lang] || MONTHS_HR;
}

export const TIME_OPTIONS = (() => {
  const arr = [];
  for (let h = 0; h < 24; h++) {
    for (const m of [0, 30]) arr.push(`${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`);
  }
  return arr;
})();
